import ICanStoreURLs from 'containers/can-store/types/url';

const CAN_STORE_URL: Readonly<ICanStoreURLs> = {
	CAN_TAB_CSS: '/Portal/Public/cantabsv3.2/cantabs-v3.2.css',
	CAN_TAB_JS: '/Portal/Public/cantabsv3.2/cantabs-v3.2.js',
};

export default CAN_STORE_URL;
